var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.8519887mm",
    height: "3.2260644mm",
    viewBox: "0 0 1.8519887 3.2260644",
    id: "svg4540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4534"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-84.496625,-97.327444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5099",
    transform: "matrix(0.26458333,0,0,0.26458333,84.231947,97.327444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5085",
    d: "M 1.533,3.568 8,12.193 V 1 H 2.812 C 1.042,1 0.474,2.156 1.533,3.568 Z",
    fill: "#0000000",
    style: {
      opacity: 0.12999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5087",
    d: "M 1.533,2.568 8,11.193 V 0 H 2.812 C 1.042,0 0.474,1.156 1.533,2.568 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatArrowLeft);
export default __webpack_public_path__ + "static/media/chat_arrow_left.8603ccad4f4407c76b6d00c30b7d21c7.svg";
export { ForwardRef as ReactComponent };